import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import { getDistrictListforEvent, getBlockList, getGpList } from "../../Service/ActivityDetailsService";
import { ToastContainer, toast } from "react-toastify";
import LOGO from "../../Img/logo.png"
import {
    getCashAnalysisUtilization,
    getCashAnalysisSummaryOB,
    getCashAnalysisSummaryDtls,
    getCashAnalysisSummaryCB,
    getCashAnalysisReceiptDtls,
    getCashAnalysisHeadDtls,
    getCashAnalysisPriGlDtls,
    getGpForm26,
    getStatus
} from "../../Service/ReportsService";
import { getLgdDetails } from "../../Service/LgdCodeService";
import * as XLSX from "xlsx";
// import * as XLSX from "xlsx-js-style";

const MonthClosingModule = () => {
    const [loadingFy, setLoadingFy] = useState(false);
    const [currentFinancialYear, setCurrentFinancialYear] = useState("");
    const [financialYears, setFinancialYears] = useState([]);
    const [data, setData] = useState([]);
    const [yearOptions, setYearOptions] = useState([]);
    const [district, setDistrict] = useState();
    const [block, setBlock] = useState();
    const [gp, setGp] = useState();
    const [getDistrictDataList, setDistrictDataList] = useState([]);
    const [getBlockDataList, setBlockDataList] = useState([]);
    const [getGpDataList, setGpDataList] = useState([]);
    const [popupData, setPopupData] = useState(null);
    const [selectedMonth, setSelectedMonth] = useState('');
    const [reportData, setReportData] = useState(null);
    const [lgd, setLgd] = useState([]);
    const [statusData, setStatus] = useState();
    const [cashAnalysisSummaryOB, setCashAnalysisSummaryOB] = useState();
    const [cashAnalysisUtilization, setCashAnalysisUtilization] = useState();
    const [cashAnalysisSummaryDtls, setCashAnalysisSummaryDtls] = useState([]);
    const [cashAnalysisSummaryCB, setCashAnalysisSummaryCB] = useState();
    const [gpForm26Dtls, setGpForm26Dtls] = useState(null);
    const [tier, setTier] = useState("");
    const [selectedFinancialYear, setSelectedFinancialYear] = useState("");
    const [loading, setLoading] = useState(false);
    const [reportLoading, setReportLoading] = useState(false);

    const userData = JSON.parse(sessionStorage.getItem('SAHAJ_SARAL_USER'));
    const printRef = useRef();

    const formatDate = (date) =>
        date ? new Date(date).toLocaleDateString("en-GB").replace(/\//g, '.') : "Invalid Date";

    const monthList = [
        'april', 'may', 'june', 'july',
        'august', 'september',
        'october', 'november', 'december',
        'january', 'february', 'march'
    ];

    const activeFinancialYear = currentFinancialYear || selectedFinancialYear;

    const isValidMonthValue = (value) =>
        value !== null &&
        value !== undefined &&
        value !== "" &&
        value !== "null" &&
        value !== "-" &&
        value !== "---";

    const shouldShowMonthValue = activeFinancialYear !== "2025-2026";

    const selectedLgdCode = String(popupData?.lgdCode ?? "").trim();
    const isCashAnalysisReport = selectedLgdCode.length > 0 && selectedLgdCode.length < 6;
    const isForm26Report = selectedLgdCode.length >= 6;

    useEffect(() => {
        const fetchFinancialYears = async () => {
            if (!userData?.CORE_LGD) return;

            try {
                setLoadingFy(true);

                const response = await axios.get(
                    `https://javaapi.wbpms.in/api/MonthClose/FinYear?lgdCode=${userData?.CORE_LGD}`
                );

                if (response?.data?.finYears && Array.isArray(response.data.finYears)) {
                    setFinancialYears(response.data.finYears);

                    if (response.data.finYears.length > 0) {
                        const defaultFy = response.data.finYears[0].finYear;
                        setCurrentFinancialYear(defaultFy);
                        setSelectedFinancialYear(defaultFy);
                    }
                }
            } catch (error) {
                console.error("Error fetching financial years:", error);
                toast.error("Failed to load financial years");
            } finally {
                setLoadingFy(false);
            }
        };

        fetchFinancialYears();
    }, [userData?.CORE_LGD]);

    useEffect(() => {
        let isCancelled = false;

        const loadSelectedReport = async () => {
            if (!popupData?.lgdCode || !popupData?.fromDate || !popupData?.toDate) {
                return;
            }

            const lgdCode = String(popupData.lgdCode).trim();
            const showCashAnalysis = lgdCode.length < 6;

            setReportLoading(true);
            setLgd([]);
            setStatus(undefined);
            setCashAnalysisSummaryOB(undefined);
            setCashAnalysisUtilization(undefined);
            setCashAnalysisSummaryDtls(null);
            setCashAnalysisSummaryCB(undefined);
            setGpForm26Dtls(null);

            try {
                if (showCashAnalysis) {
                    const [
                        lgdResponse,
                        statusResponse,
                        closingBalanceResponse,
                        detailsResponse,
                        openingBalanceResponse,
                        utilizationResponse
                    ] = await Promise.all([
                        getLgdDetails(lgdCode),
                        getStatus(lgdCode, popupData.fromDate, popupData.toDate),
                        getCashAnalysisSummaryCB(
                            lgdCode,
                            activeFinancialYear,
                            popupData.fromDate,
                            popupData.toDate
                        ),
                        getCashAnalysisSummaryDtls(
                            lgdCode,
                            popupData.fromDate,
                            popupData.toDate
                        ),
                        getCashAnalysisSummaryOB(
                            lgdCode,
                            activeFinancialYear,
                            popupData.fromDate,
                            popupData.toDate
                        ),
                        getCashAnalysisUtilization(
                            lgdCode,
                            popupData.fromDate,
                            popupData.toDate
                        )
                    ]);

                    if (isCancelled) return;

                    if (lgdResponse?.status === 200) setLgd(lgdResponse.data || []);
                    if (statusResponse?.status === 200) setStatus(statusResponse.data);
                    if (closingBalanceResponse?.status === 200) setCashAnalysisSummaryCB(closingBalanceResponse.data);
                    if (detailsResponse?.status === 200) setCashAnalysisSummaryDtls(detailsResponse.data);
                    if (openingBalanceResponse?.status === 200) setCashAnalysisSummaryOB(openingBalanceResponse.data);
                    if (utilizationResponse?.status === 200) setCashAnalysisUtilization(utilizationResponse.data);

                    const statusMessage = statusResponse?.data?.statusMsg;
                    statusMessage === "Success"
                        ? toast.success("Cash Analysis fetched successfully")
                        : statusMessage && toast.error(statusMessage);
                } else {
                    const [lgdResponse, statusResponse, form26Response] = await Promise.all([
                        getLgdDetails(lgdCode),
                        getStatus(lgdCode, popupData.fromDate, popupData.toDate),
                        getGpForm26(lgdCode, popupData.fromDate, popupData.toDate)
                    ]);

                    if (isCancelled) return;

                    if (lgdResponse?.status === 200) setLgd(lgdResponse.data || []);
                    if (statusResponse?.status === 200) setStatus(statusResponse.data);
                    if (form26Response?.status === 200) setGpForm26Dtls(form26Response.data);

                    const statusMessage = form26Response?.data?.statusMsg || statusResponse?.data?.statusMsg;
                    statusMessage === "Success"
                        ? toast.success("Form 26 fetched successfully")
                        : statusMessage && toast.error(statusMessage);
                }
            } catch (error) {
                console.error("Error fetching selected report:", error);
                if (!isCancelled) {
                    toast.error("Failed to fetch report data");
                }
            } finally {
                if (!isCancelled) {
                    setReportLoading(false);
                }
            }
        };

        loadSelectedReport();

        return () => {
            isCancelled = true;
        };
    }, [popupData, activeFinancialYear]);

    const handlePrint = () => {
        const printContent = printRef.current.innerHTML;
        const myWindow = window.open("", "prnt_area", "height=800,width=700");

        myWindow.document.write(`
            <html>
            <head>
                <title>${isForm26Report ? "Form 26" : "Cash Analysis"}</title>
                <style>
                    .mm p{position:absolute;top:150px;right:20px !important;}
                    .col-span-12{text-align:center;}
                    p {line-height:.5 !important;}
                    .clearfix{clear:both;}

                    .prd}{float:left; font-weight:bold;text-align:left;margin:10px !important;padding:0 !important;}
                    .stts{float:right; font-weight:bold;text-align:right;margin:10px !important;padding:0 !important;}
                    .logo{float:left;}
                    .info h2{text-align:center}
                    .prn-dt{text-align:right !important;position:absolute;top:0px;right:0px !important;}
                    .info{text-align:center !important}
                    .info p{text-align:center !important}
                    .info span{text-align:center}
                    .xx{position:relative;}

                    @media print {
                        .hh {
                            border-width: 0 !important;
                        }

                        .info h2{text-align:center}
                        .prn-dt{text-align:right !important;}
                        .info{text-align:center !important;margin:0 !important;padding:0 !important}
                        .info p{text-align:center !important;margin:0 !important;padding:0 !important}
                        .info span{text-align:center;margin:0 !important;padding:0 !important}
                        .mylogo img{width:100px;}
                        .redclr {color:red}
                        .tbsize {font-size:12px}
                        .smallbold {font-size:12px;font-weight:bold;}
                        .rightall {text-align:right;}
                        .bigbold {font-size:20px;font-weight:bold;}
                        .vv p>span{line-height:1;margin-bottom:5px;}
                        .vv {margin-top:25px;border-top:1px solid #ccc;}
                        thead { display: table-header-group; }
                        tfoot { display: table-footer-group; }
                        table { width: 100%; border-collapse: collapse; }
                        th, td { border: 1px solid black; padding: 8px;}

                        .vert div {
                            writing-mode: vertical-rl;
                            transform: rotate(180deg);
                            white-space: nowrap;
                            text-align: center;
                            height: 8rem;
                            width: 2.5rem;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                        }

                        .parti {
                            width:300px !important;
                            max-width: 300px !important;
                            min-width: 300px !important;
                            white-space: normal !important;
                            word-wrap: break-word !important;
                            overflow-wrap: break-word !important;
                        }

                        .openClr {
                            background-color: #cce5ff !important;
                        }

                        .whiteclr {
                            color: #fff !important;
                        }

                        .blueclr {
                            color: #cce5ff !important;
                        }

                        .foot {
                            text-align: center !important;
                            font-style: italic;
                            margin:30px !important;
                            padding:0 !important;
                        }
                    }
                </style>
            </head>
            <body>
                ${printContent}
            </body>
            </html>
        `);

        myWindow.document.close();
        myWindow.focus();
        myWindow.print();
        myWindow.close();
    };

    const handleMonthClick = (monthKey, row) => {
        if (!activeFinancialYear) {
            toast.error("Please select financial year first");
            return;
        }

        const [startYear, endYear] = activeFinancialYear.split("-").map(Number);

        if (!startYear || !endYear) {
            toast.error("Invalid financial year selected");
            return;
        }

        const monthMap = {
            april: 3,
            may: 4,
            june: 5,
            july: 6,
            august: 7,
            september: 8,
            october: 9,
            november: 10,
            december: 11,
            january: 0,
            february: 1,
            march: 2,
        };

        const lowerCaseMonth = monthKey.toLowerCase();
        const monthIndex = monthMap[lowerCaseMonth];

        const year = monthIndex >= 3 ? startYear : endYear;

        const firstDay = new Date(Date.UTC(year, monthIndex, 1));
        const lastDay = new Date(Date.UTC(year, monthIndex + 1, 0));

        setReportLoading(true);
        setCashAnalysisSummaryDtls(null);
        setGpForm26Dtls(null);

        setPopupData({
            ...row,
            lgdCode: String(row?.lgdCode ?? "").trim(),
            fromDate: firstDay.toISOString().split("T")[0],
            toDate: lastDay.toISOString().split("T")[0],
        });

        setSelectedMonth(monthKey.charAt(0).toUpperCase() + monthKey.slice(1));
    };

    const closePopup = () => {
        setPopupData(null);
        setSelectedMonth('');
        setReportLoading(false);
        setCashAnalysisSummaryDtls(null);
        setGpForm26Dtls(null);
    };

    useEffect(() => {
        const today = new Date();
        const currentYear = today.getFullYear();
        const currentMonth = today.getMonth();

        const fyStartYear = currentMonth >= 3 ? currentYear : currentYear - 1;

        const years = [];

        for (let i = 0; i < 1; i++) {
            const start = fyStartYear - i;
            const end = start + 1;
            years.push(`${start}-${end}`);
        }

        setYearOptions(years);
    }, []);

    const totals = {
        openingBalance: 0,
        receiptAmount: 0,
        paymentAmount: 0,
        closingBalance: 0
    };

    cashAnalysisSummaryDtls?.dtls?.forEach(item => {
        totals.openingBalance += parseFloat(item.openingBalance) || 0;
        totals.receiptAmount += parseFloat(item.receiptAmount) || 0;
        totals.paymentAmount += parseFloat(item.paymentAmount) || 0;
        totals.closingBalance += parseFloat(item.closingBalance) || 0;
    });

    const fetchData = async () => {
        if (!district) {
            toast.error("Please select District");
            return;
        }

        if (!tier) {
            toast.error("Please select a Tier");
            return;
        }

        if (!selectedFinancialYear) {
            toast.error("Please select a financial year");
            return;
        }

        setLoading(true);
        setCurrentFinancialYear(selectedFinancialYear);

        try {
            const res = await axios.get(
                "https://javaapi.wbpms.in/api/MonthClose/MonthClosing",
                {
                    params: {
                        distLgd: district || 0,
                        blkLgd: block || 0,
                        gpLgd: gp || 0,
                        finYear: selectedFinancialYear,
                        lgdType: tier,
                    },
                }
            );

            setData(res.data || []);
        } catch (error) {
            console.error(error);
            toast.error("Error fetching data");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const data = JSON.parse(sessionStorage.getItem("SAHAJ_SARAL_USER"));

        getDistrictListforEvent(data?.DIST_LGD || 0).then((res) => {
            setDistrictDataList(res?.data || []);
            setDistrict(data?.DIST_LGD || 0);
        });

        getBlockList(data?.DIST_LGD || 0, data?.BLOCK_LGD || 0).then((res) => {
            setBlockDataList(res?.data || []);
            setBlock(data?.BLOCK_LGD || 0);
        });

        getGpList(data?.DIST_LGD || 0, data?.BLOCK_LGD || 0, data?.GP_LGD || 0).then((res) => {
            setGpDataList(res?.data || []);
            setGp(data?.GP_LGD || 0);
        });
    }, []);

    const onDistrict = (e) => {
        const val = e.target.value;
        setDistrict(val);
        setBlock('');
        setGp('');
        getBlockList(val, 0).then(res => setBlockDataList(res?.data || []));
    };

    const onBlock = (e) => {
        const val = e.target.value;
        setBlock(val);
        setGp('');
        getGpList(district, val, 0).then(res => setGpDataList(res?.data || []));
    };

    const handleListingExcelDownload = () => {
        if (!Array.isArray(data) || data.length === 0) {
            toast.error("No listing data available to download");
            return;
        }

        const now = new Date();

        const downloadDate = now
            .toLocaleDateString("en-GB")
            .replace(/\//g, "-");

        const downloadDateTime = now.toLocaleString("en-GB");

        const monthColumns = [
            { key: "april", label: "April" },
            { key: "may", label: "May" },
            { key: "june", label: "June" },
            { key: "july", label: "July" },
            { key: "august", label: "August" },
            { key: "september", label: "September" },
            { key: "october", label: "October" },
            { key: "november", label: "November" },
            { key: "december", label: "December" },
            { key: "january", label: "January" },
            { key: "february", label: "February" },
            { key: "march", label: "March" },
        ];

        const financialYear =
            activeFinancialYear ||
            selectedFinancialYear ||
            "";

        const excelData = data.map((row, index) => {
            const excelRow = {
                "Sl No": index + 1,
                "District": row?.distName || "",
                "Block": row?.blockName || "-",
                "PRI Name": row?.lgdName || "",
                "LGD Code": row?.lgdCode || "",
            };

            monthColumns.forEach(({ key, label }) => {
                excelRow[label] = isValidMonthValue(row?.[key])
                    ? row[key]
                    : "";
            });

            excelRow["Financial Year"] = financialYear;
            excelRow["Downloaded On"] = downloadDateTime;

            return excelRow;
        });

        const worksheet = XLSX.utils.json_to_sheet(excelData);

        /*
         * Excel row 1 contains headers.
         * Actual data starts from row 2.
         */
        const range = XLSX.utils.decode_range(worksheet["!ref"]);

        // Header styling
        for (let columnIndex = range.s.c; columnIndex <= range.e.c; columnIndex++) {
            const headerAddress = XLSX.utils.encode_cell({
                r: 0,
                c: columnIndex,
            });

            if (!worksheet[headerAddress]) continue;

            worksheet[headerAddress].s = {
                font: {
                    bold: true,
                    color: { rgb: "000000" },
                },
                fill: {
                    patternType: "solid",
                    fgColor: { rgb: "B4C6E7" },
                },
                alignment: {
                    horizontal: "center",
                    vertical: "center",
                    wrapText: true,
                },
                border: {
                    top: {
                        style: "thin",
                        color: { rgb: "808080" },
                    },
                    bottom: {
                        style: "thin",
                        color: { rgb: "808080" },
                    },
                    left: {
                        style: "thin",
                        color: { rgb: "808080" },
                    },
                    right: {
                        style: "thin",
                        color: { rgb: "808080" },
                    },
                },
            };
        }

        /*
         * Month columns begin after:
         * Sl No, District, Block, PRI Name and LGD Code.
         *
         * Therefore April starts at zero-based column index 5.
         */
        const firstMonthColumnIndex = 5;

        data.forEach((row, rowIndex) => {
            monthColumns.forEach(({ key }, monthIndex) => {
                const excelRowIndex = rowIndex + 1;
                const excelColumnIndex =
                    firstMonthColumnIndex + monthIndex;

                const cellAddress = XLSX.utils.encode_cell({
                    r: excelRowIndex,
                    c: excelColumnIndex,
                });

                // Create the cell when the month contains no value
                if (!worksheet[cellAddress]) {
                    worksheet[cellAddress] = {
                        t: "s",
                        v: "",
                    };
                }

                const hasData = isValidMonthValue(row?.[key]);

                worksheet[cellAddress].s = {
                    fill: {
                        patternType: "solid",
                        fgColor: {
                            // Green when data exists, red when no data exists
                            rgb: hasData ? "C6EFCE" : "FFC7CE",
                        },
                    },
                    font: {
                        bold: true,
                        color: {
                            rgb: hasData ? "006100" : "9C0006",
                        },
                    },
                    alignment: {
                        horizontal: "center",
                        vertical: "center",
                        wrapText: true,
                    },
                    border: {
                        top: {
                            style: "thin",
                            color: { rgb: "B7B7B7" },
                        },
                        bottom: {
                            style: "thin",
                            color: { rgb: "B7B7B7" },
                        },
                        left: {
                            style: "thin",
                            color: { rgb: "B7B7B7" },
                        },
                        right: {
                            style: "thin",
                            color: { rgb: "B7B7B7" },
                        },
                    },
                };
            });
        });

        worksheet["!cols"] = [
            { wch: 8 },  // Sl No
            { wch: 22 }, // District
            { wch: 25 }, // Block
            { wch: 35 }, // PRI Name
            { wch: 14 }, // LGD Code
            { wch: 15 }, // April
            { wch: 15 }, // May
            { wch: 15 }, // June
            { wch: 15 }, // July
            { wch: 15 }, // August
            { wch: 15 }, // September
            { wch: 15 }, // October
            { wch: 15 }, // November
            { wch: 15 }, // December
            { wch: 15 }, // January
            { wch: 15 }, // February
            { wch: 15 }, // March
            { wch: 18 }, // Financial Year
            { wch: 24 }, // Downloaded On
        ];

        worksheet["!rows"] = [
            { hpt: 25 },
        ];

        worksheet["!autofilter"] = {
            ref: worksheet["!ref"],
        };

        // Freeze the header row
        worksheet["!freeze"] = {
            xSplit: 0,
            ySplit: 1,
            topLeftCell: "A2",
            activePane: "bottomLeft",
            state: "frozen",
        };

        const workbook = XLSX.utils.book_new();

        XLSX.utils.book_append_sheet(
            workbook,
            worksheet,
            "Month Closing Status"
        );

        const fileYear =
            financialYear || "All_Financial_Years";

        const fileName =
            `Monthly_Account_Closing_${fileYear}_${downloadDate}.xlsx`;

        XLSX.writeFile(workbook, fileName);

        toast.success("Excel downloaded successfully");
    };

    return (
        <div className="bg-white rounded-lg p-2 flex flex-col flex-grow" style={{ marginTop: "-40px" }}>
            <ToastContainer />
            <h2 className="text-lg font-semibold text-cyan-700 mb-4">Monthly Account Closing Status</h2>

            {/* Filters */}
            <div className="grid grid-cols-1 md:grid-cols-5 gap-4 mb-4">
                <div>
                    <label className="text-sm font-medium">
                        District<span className="text-red-500">*</span>
                    </label>

                    <select
                        className="text-sm block w-full p-1 h-9 border border-gray-300 rounded-md"
                        value={district || ''}
                        onChange={onDistrict}
                    >
                        <option value="">--Select District--</option>

                        {getDistrictDataList.map((d, i) => (
                            <option key={i} value={d.DistLgd}>
                                {d.DistName}
                            </option>
                        ))}
                    </select>
                </div>

                <div>
                    <label className="text-sm font-medium">Block</label>

                    <select
                        className="text-sm block w-full p-1 h-9 border border-gray-300 rounded-md"
                        value={block || ''}
                        onChange={onBlock}
                    >
                        <option value="">--Select Block--</option>

                        {getBlockDataList.map((b, i) => (
                            <option key={i} value={b.BlockLgd}>
                                {b.BlockName}
                            </option>
                        ))}
                    </select>
                </div>

                <div>
                    <label className="text-sm font-medium">Gram Panchayat</label>

                    <select
                        className="text-sm block w-full p-1 h-9 border border-gray-300 rounded-md"
                        value={gp || ''}
                        onChange={e => setGp(e.target.value)}
                    >
                        <option value="">--Select GP--</option>

                        {getGpDataList.map((g, i) => (
                            <option key={i} value={g.GPLgd}>
                                {g.GPName}
                            </option>
                        ))}
                    </select>
                </div>

                <div>
                    <label className="text-sm font-medium">
                        Tier<span className="text-red-500">*</span>
                    </label>

                    <select
                        className="text-sm block w-full p-1 h-9 border border-gray-300 rounded-md"
                        value={tier}
                        onChange={e => setTier(e.target.value)}
                    >
                        <option value="">--Select Tier--</option>
                        <option value="1">Zilla Parishad</option>
                        <option value="2">Panchayat Samiti</option>
                        <option value="3">Gram Panchayat</option>
                        <option value="0">ALL</option>
                    </select>
                </div>

                <div>
                    <label className="text-sm font-medium">
                        Financial Year<span className="text-red-500">*</span>
                    </label>

                    <select
                        className="text-sm block w-full p-1 h-9 border border-gray-300 rounded-md"
                        value={selectedFinancialYear}
                        onChange={(e) => setSelectedFinancialYear(e.target.value)}
                    >
                        <option value="">
                            {loadingFy ? "Loading..." : "--Select Financial Year--"}
                        </option>
                        <option value="2025-2026">2025-2026</option>
                        <option value="2026-2027">2026-2027</option>
                    </select>
                </div>
            </div>

            <div className="flex justify-center items-end gap-3 mb-4">
                <button
                    type="button"
                    onClick={fetchData}
                    disabled={loading}
                    className="bg-cyan-600 text-white px-4 py-2 rounded hover:bg-cyan-700 disabled:opacity-50"
                >
                    {loading ? "Loading..." : "Search"}
                </button>

                <button
                    type="button"
                    onClick={handleListingExcelDownload}
                    disabled={loading || data.length === 0}
                    className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                    Download Excel
                </button>
            </div>

            {/* Table */}
            {loading ? (
                <div className="flex justify-center items-center py-10">
                    <div className="w-10 h-10 border-4 border-cyan-500 border-t-transparent rounded-full animate-spin"></div>
                </div>
            ) : (
                data.length > 0 && (
                    <>
                        {/* Important information */}
                        <div className="mb-3 rounded-md border border-amber-300 bg-amber-50 px-4 py-3 text-sm text-amber-900">
                            <span className="font-bold"></span>{" "}
                            Click the green tick{" "}
                            <span className="inline-flex items-center justify-center rounded bg-green-100 px-2 py-0.5 font-bold text-green-700">
                                ✓
                            </span>{" "}
                            to view ZP-PS Cash Analysis/GP Form-26
                        </div>

                        <div className="overflow-auto">
                            <table className="min-w-full border text-sm text-center">
                                <thead className="bg-blue-200">
                                    <tr>
                                        <th className="border p-2">District</th>
                                        <th className="border p-2">Block</th>
                                        <th className="border p-2">PRI Name</th>

                                        {monthList.map((month) => (
                                            <th
                                                key={month}
                                                className="border p-2 capitalize"
                                            >
                                                {month}
                                            </th>
                                        ))}
                                    </tr>
                                </thead>

                                <tbody>
                                    {data.map((row, i) => (
                                        <tr key={i} className="hover:bg-blue-50">
                                            <td className="border p-2">
                                                {row.distName}
                                            </td>

                                            <td className="border p-2">
                                                {row.blockName || "-"}
                                            </td>

                                            <td className="border p-2">
                                                {row.lgdName}
                                            </td>

                                            {monthList.map((month) => {
                                                const value = row[month];

                                                const hasData =
                                                    isValidMonthValue(value);

                                                return (
                                                    <td
                                                        key={month}
                                                        className={`border p-2 text-center ${hasData
                                                                ? "cursor-pointer hover:bg-green-50"
                                                                : "pointer-events-none opacity-60"
                                                            }`}
                                                        onClick={() =>
                                                            hasData &&
                                                            handleMonthClick(month, row)
                                                        }
                                                    >
                                                        {hasData ? (
                                                            <div className="flex flex-col items-center">
                                                                <span className="inline-block rounded bg-green-100 px-2 py-1 font-bold text-green-700">
                                                                    ✓
                                                                </span>

                                                                <span className="mt-1 text-xs text-gray-600">
                                                                    {value}
                                                                </span>
                                                            </div>
                                                        ) : (
                                                            <span className="inline-block rounded bg-red-100 px-2 py-1 font-bold text-red-700">
                                                                ✗
                                                            </span>
                                                        )}
                                                    </td>
                                                );
                                            })}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </>
                )
            )}

            {/* Popup for report */}
            {popupData && (
                <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
                    <div className="bg-white p-4 rounded-md w-11/12 max-w-5xl relative shadow-lg overflow-auto max-h-[90vh]">
                        <button
                            className="absolute top-2 right-2 text-red-600 font-bold text-lg"
                            onClick={closePopup}
                        >
                            ✕
                        </button>

                        <h2 className="text-lg font-semibold text-center text-cyan-700 mb-2">
                            {isForm26Report ? "Form 26" : "Cash Analysis"} for {selectedMonth}{" "}
                            {formatDate(popupData.fromDate)} to {formatDate(popupData.toDate)}
                        </h2>

                        {reportLoading && (
                            <div className="flex justify-center items-center py-10">
                                <div className="w-10 h-10 border-4 border-cyan-500 border-t-transparent rounded-full animate-spin"></div>
                            </div>
                        )}

                        {!reportLoading && isCashAnalysisReport && cashAnalysisSummaryDtls?.dtls?.length > 0 ? (
                            <>
                                <div className="bg-white shadow-lg border text-xs">
                                    <div
                                        ref={printRef}
                                        id="voucher-container"
                                        style={{ position: "relative" }}
                                        className="bg-white p-4 shadow-lg text-xs"
                                    >
                                        <div
                                            className="mylogo"
                                            style={{ position: "absolute", top: 0, right: 20 }}
                                        >
                                            <img
                                                src={LOGO}
                                                alt="Company Logo"
                                                className="w-20 h-18 object-contain"
                                            />
                                        </div>

                                        <div className="grid">
                                            <div className="col-span-12">
                                                <p
                                                    className="text-center font-bold text-xl text-black-700 bigbold"
                                                    style={{ fontFamily: "InterVariable, sans-serif" }}
                                                >
                                                    {lgd[0]?.lsgName}
                                                </p>

                                                <p
                                                    className="text-center font-bold text-xl text-black-700 bigbold"
                                                    style={{ fontFamily: "InterVariable, sans-serif" }}
                                                >
                                                    {lgd[0]?.lgdAdd1}
                                                </p>

                                                <div
                                                    className="text-center font-bold text-lg text-cyan-700 bigbold mb-4"
                                                    style={{
                                                        fontFamily: "InterVariable, sans-serif",
                                                        marginBottom: "0px"
                                                    }}
                                                >
                                                    Cash Analysis (Summary)-{statusData?.statusTag}
                                                </div>

                                                <div
                                                    className="text-center font-semibold text-sm text-cyan-700"
                                                    style={{
                                                        fontFamily: "InterVariable, sans-serif",
                                                        marginTop: "5px"
                                                    }}
                                                >
                                                    Period: {formatDate(popupData.fromDate)} to {formatDate(popupData.toDate)}
                                                </div>
                                            </div>
                                        </div>

                                        <div className="text-sm text-left tbsize" style={{ marginBottom: 10 }}>
                                            <p style={{ fontFamily: "InterVariable, sans-serif" }}>
                                                <span
                                                    className="smallbold font-bold text-cyan-700"
                                                    style={{
                                                        fontFamily: "InterVariable, sans-serif",
                                                        lineHeight: .5
                                                    }}
                                                >
                                                    Opening Balance:
                                                </span>{" "}
                                                {cashAnalysisSummaryOB?.totalOB}
                                            </p>

                                            <p style={{ fontFamily: "InterVariable, sans-serif" }}>
                                                <span
                                                    className="smallbold font-bold text-cyan-700"
                                                    style={{
                                                        fontFamily: "InterVariable, sans-serif",
                                                        lineHeight: .5
                                                    }}
                                                >
                                                    Bank:
                                                </span>{" "}
                                                {cashAnalysisSummaryOB?.bank}
                                            </p>

                                            <p style={{ fontFamily: "InterVariable, sans-serif" }}>
                                                <span
                                                    className="smallbold font-bold text-cyan-700"
                                                    style={{
                                                        fontFamily: "InterVariable, sans-serif",
                                                        lineHeight: .5
                                                    }}
                                                >
                                                    Treasury:
                                                </span>{" "}
                                                {cashAnalysisSummaryOB?.treasury}
                                            </p>

                                            <p style={{ fontFamily: "InterVariable, sans-serif" }}>
                                                <span
                                                    className="smallbold font-bold text-cyan-700"
                                                    style={{
                                                        fontFamily: "InterVariable, sans-serif",
                                                        lineHeight: .5
                                                    }}
                                                >
                                                    Cash:
                                                </span>{" "}
                                                {cashAnalysisSummaryOB?.cash}
                                            </p>
                                        </div>

                                        <div className="mt-2 overflow-x-auto">
                                            <table className="w-full border-collapse border text-xs">
                                                <thead>
                                                    <tr className="text-black-700 smallbold">
                                                        <th className="border p-2" style={{ fontFamily: "InterVariable, sans-serif" }}>
                                                            Sl No
                                                        </th>
                                                        <th className="border p-2" style={{ fontFamily: "InterVariable, sans-serif" }}>
                                                            Head of Account
                                                        </th>
                                                        <th className="border p-2" style={{ fontFamily: "InterVariable, sans-serif" }}>
                                                            Opening Balance
                                                        </th>
                                                        <th className="border p-2" style={{ fontFamily: "InterVariable, sans-serif" }}>
                                                            Receipt
                                                        </th>
                                                        <th className="border p-2" style={{ fontFamily: "InterVariable, sans-serif" }}>
                                                            Payment
                                                        </th>
                                                        <th className="border p-2" style={{ fontFamily: "InterVariable, sans-serif" }}>
                                                            Closing Balance
                                                        </th>
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    {cashAnalysisSummaryDtls?.dtls?.map((entry, index) => (
                                                        <tr key={index} className="text-right tbsize">
                                                            <td
                                                                className="border p-2 text-right rightall"
                                                                style={{ fontFamily: "InterVariable, sans-serif" }}
                                                            >
                                                                {index + 1}
                                                            </td>

                                                            <td
                                                                className="border p-2 text-left"
                                                                style={{ fontFamily: "InterVariable, sans-serif" }}
                                                            >
                                                                {entry?.glGroupName}
                                                            </td>

                                                            <td
                                                                className={
                                                                    entry?.openingBalance < 0
                                                                        ? "border p-2 text-red-600 redclr rightall"
                                                                        : "border p-2 rightall"
                                                                }
                                                                style={{ fontFamily: "InterVariable, sans-serif" }}
                                                            >
                                                                {entry?.openingBalance}
                                                            </td>

                                                            <td
                                                                className={
                                                                    entry?.receiptAmount < 0
                                                                        ? "border p-2 text-red-600 redclr rightall"
                                                                        : "border p-2 rightall"
                                                                }
                                                                style={{ fontFamily: "InterVariable, sans-serif" }}
                                                            >
                                                                {entry?.receiptAmount}
                                                            </td>

                                                            <td
                                                                className={
                                                                    entry?.paymentAmount < 0
                                                                        ? "border p-2 text-red-600 redclr rightall"
                                                                        : "border p-2 rightall"
                                                                }
                                                                style={{ fontFamily: "InterVariable, sans-serif" }}
                                                            >
                                                                {entry?.paymentAmount}
                                                            </td>

                                                            <td
                                                                className={
                                                                    entry?.closingBalance < 0
                                                                        ? "border p-2 text-red-600 redclr rightall"
                                                                        : "border p-2 rightall"
                                                                }
                                                                style={{ fontFamily: "InterVariable, sans-serif" }}
                                                            >
                                                                {entry?.closingBalance}
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>

                                                <tfoot>
                                                    <tr className="bg-gray-300 font-bold text-black tbsize rightall">
                                                        <td
                                                            colSpan="2"
                                                            className="border p-2 text-right"
                                                            style={{ fontFamily: "InterVariable, sans-serif" }}
                                                        >
                                                            Grand Total:
                                                        </td>

                                                        <td
                                                            className="border p-2 text-right"
                                                            style={{ fontFamily: "InterVariable, sans-serif" }}
                                                        >
                                                            {(totals?.openingBalance).toFixed(2)}
                                                        </td>

                                                        <td
                                                            className="border p-2 text-right"
                                                            style={{ fontFamily: "InterVariable, sans-serif" }}
                                                        >
                                                            {(totals?.receiptAmount).toFixed(2)}
                                                        </td>

                                                        <td
                                                            className="border p-2 text-right"
                                                            style={{ fontFamily: "InterVariable, sans-serif" }}
                                                        >
                                                            {(totals?.paymentAmount).toFixed(2)}
                                                        </td>

                                                        <td
                                                            className="border p-2 text-right"
                                                            style={{ fontFamily: "InterVariable, sans-serif" }}
                                                        >
                                                            {(totals?.closingBalance).toFixed(2)}
                                                        </td>
                                                    </tr>
                                                </tfoot>
                                            </table>
                                        </div>

                                        <div className="text-sm text-right tbsize" style={{ textAlign: "right" }}>
                                            <p style={{ fontFamily: "InterVariable, sans-serif" }}>
                                                <span
                                                    className="smallbold font-bold text-cyan-700"
                                                    style={{
                                                        fontFamily: "InterVariable, sans-serif",
                                                        lineHeight: .5
                                                    }}
                                                >
                                                    Closing Balance:
                                                </span>{" "}
                                                {cashAnalysisSummaryCB?.totalCB}
                                            </p>

                                            <p style={{ fontFamily: "InterVariable, sans-serif" }}>
                                                <span
                                                    className="smallbold font-bold text-cyan-700"
                                                    style={{
                                                        fontFamily: "InterVariable, sans-serif",
                                                        lineHeight: .5
                                                    }}
                                                >
                                                    Bank:
                                                </span>{" "}
                                                {cashAnalysisSummaryCB?.bank}
                                            </p>

                                            <p style={{ fontFamily: "InterVariable, sans-serif" }}>
                                                <span
                                                    className="smallbold font-bold text-cyan-700"
                                                    style={{
                                                        fontFamily: "InterVariable, sans-serif",
                                                        lineHeight: .5
                                                    }}
                                                >
                                                    Treasury:
                                                </span>{" "}
                                                {cashAnalysisSummaryCB?.treasury}
                                            </p>

                                            <p style={{ fontFamily: "InterVariable, sans-serif" }}>
                                                <span
                                                    className="smallbold font-bold text-cyan-700"
                                                    style={{
                                                        fontFamily: "InterVariable, sans-serif",
                                                        lineHeight: .5
                                                    }}
                                                >
                                                    Cash:
                                                </span>{" "}
                                                {cashAnalysisSummaryCB?.cash}
                                            </p>
                                        </div>

                                        <div className="mt-4 text-sm flex justify-between">
                                            <div className="space-y-1 text-left vv">
                                                <p style={{ fontFamily: "InterVariable, sans-serif" }}>
                                                    <span
                                                        className="tbsize font-bold text-cyan-700"
                                                        style={{ fontFamily: "InterVariable, sans-serif" }}
                                                    >
                                                        Available Fund:{cashAnalysisUtilization?.availableFund}
                                                    </span>
                                                </p>

                                                <p style={{ fontFamily: "InterVariable, sans-serif" }}>
                                                    <span
                                                        className="tbsize font-bold text-cyan-700"
                                                        style={{ fontFamily: "InterVariable, sans-serif" }}
                                                    >
                                                        Expenditure:{cashAnalysisUtilization?.expenditureAmount}
                                                    </span>
                                                </p>

                                                <p style={{ fontFamily: "InterVariable, sans-serif" }}>
                                                    <span
                                                        className="tbsize font-bold text-cyan-700"
                                                        style={{ fontFamily: "InterVariable, sans-serif" }}
                                                    >
                                                        Percentage of utilization:{cashAnalysisUtilization?.percentageUtilization}
                                                    </span>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="flex justify-center space-x-4 py-1">
                                    <div className="text-right text-xs mt-4 italic">
                                        <button
                                            className="bg-green-500 text-white px-4 py-1 text-xs rounded hover:bg-green-600 transition duration-200"
                                            onClick={handlePrint}
                                        >
                                            Download PDF
                                        </button>
                                    </div>
                                </div>
                            </>
                        ) : ""}

                        {!reportLoading && isForm26Report && gpForm26Dtls?.dtls?.length > 0 && (
                            <>
                                <div className="bg-white shadow-lg border text-xs">
                                    <div
                                        ref={printRef}
                                        id="voucher-container"
                                        style={{ position: "relative" }}
                                        className="bg-white p-4 shadow-lg text-xs"
                                    >
                                        <div
                                            className="mylogo"
                                            style={{ position: "absolute", top: 0, right: 20 }}
                                        >
                                            <img
                                                src={LOGO}
                                                alt="Company Logo"
                                                className="w-20 h-18 object-contain"
                                            />
                                        </div>

                                        <div className="grid">
                                            <div className="col-span-12">
                                                <p
                                                    className="text-center font-bold text-xl text-black-700 bigbold"
                                                    style={{ fontFamily: "InterVariable, sans-serif" }}
                                                >
                                                    {lgd[0]?.lsgName}
                                                </p>

                                                <p
                                                    className="text-center font-bold text-xl text-black-700 bigbold"
                                                    style={{ fontFamily: "InterVariable, sans-serif" }}
                                                >
                                                    {lgd[0]?.lgdAdd1}
                                                </p>

                                                <p
                                                    className="text-center font-bold text-xl text-cyan-700 bigbold"
                                                    style={{ fontFamily: "InterVariable, sans-serif" }}
                                                >
                                                    FORM 26 [SEE RULE 27(1)]
                                                </p>

                                                <p
                                                    className="text-center font-bold text-xl text-cyan-700 bigbold"
                                                    style={{ fontFamily: "InterVariable, sans-serif" }}
                                                >
                                                    MONTHLY STATEMENT OF FUND POSITION
                                                </p>

                                                <div
                                                    className="text-center font-bold text-lg text-cyan-700 bigbold mb-4"
                                                    style={{
                                                        fontFamily: "InterVariable, sans-serif",
                                                        marginBottom: "0px"
                                                    }}
                                                >
                                                    {statusData?.statusTag}
                                                </div>
                                            </div>
                                        </div>

                                        <div className="text-left font-semibold text-sm text-cyan-700">
                                            Period: {formatDate(popupData.fromDate)} to {formatDate(popupData.toDate)}
                                        </div>

                                        <div className="mt-2 overflow-x-auto">
                                            <table className="w-full border-collapse border text-xs">
                                                <thead>
                                                    <tr className="text-black-700">
                                                        <th className="border p-2">CLASSIFICATION OF FUND</th>
                                                        <th className="border p-2">BALANCE OF FUND AT THE BEGINNING OF THE MONTH</th>
                                                        <th className="border p-2">FUND RECEIVED DURING THE MONTH</th>
                                                        <th className="border p-2">TOTAL FUND AVAILABLE<br />(COL 2 + COL 3)</th>
                                                        <th className="border p-2">PAYMENT MADE DURING THE MONTH</th>
                                                        <th className="border p-2">BALANCE FUND AVAILABLE<br />(COL 4 - COL 5)</th>
                                                        <th className="border p-2">PAYMENT COMMITMENT [TOTAL PENDING PAYMENT]</th>
                                                        <th className="border p-2">NET BALANCE<br />(COL 6 - COL 7)</th>
                                                    </tr>
                                                    <tr className="text-black-700">
                                                        <th className="border p-2">[1]</th>
                                                        <th className="border p-2">[2]</th>
                                                        <th className="border p-2">[3]</th>
                                                        <th className="border p-2">[4]</th>
                                                        <th className="border p-2">[5]</th>
                                                        <th className="border p-2">[6]</th>
                                                        <th className="border p-2">[7]</th>
                                                        <th className="border p-2">[8]</th>
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    {gpForm26Dtls?.dtls?.map((entry, index) => (
                                                        <tr
                                                            key={index}
                                                            className={
                                                                entry?.receiptGroupId
                                                                    ? "font-bold bg-blue-200 text-right tbsize"
                                                                    : entry?.receiptGroupName === "SUB TOTAL"
                                                                        ? "font-bold text-right tbsize"
                                                                        : "text-right tbsize"
                                                            }
                                                        >
                                                            <td className="border p-2 text-left">{entry?.receiptGroupName}</td>
                                                            <td className="border p-2 rightall">{entry?.openingBalance}</td>
                                                            <td className="border p-2 rightall">{entry?.receiptAmount}</td>
                                                            <td className="border p-2 rightall">{entry?.fundTotal}</td>
                                                            <td className="border p-2 rightall">{entry?.paymentAmount}</td>
                                                            <td className="border p-2 rightall">{entry?.fundAvailable}</td>
                                                            <td className="border p-2 rightall">{entry?.paymentCommitment}</td>
                                                            <td className="border p-2 rightall">{entry?.closingBalance}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>

                                                <tfoot>
                                                    <tr className="text-right text-black-800 font-bold">
                                                        <td className="border p-2 text-left">GRAND TOTAL</td>
                                                        <td className="border p-2">{gpForm26Dtls?.total?.totalOpeningBalance}</td>
                                                        <td className="border p-2">{gpForm26Dtls?.total?.totalReceiptAmount}</td>
                                                        <td className="border p-2">{gpForm26Dtls?.total?.totalFundTotal}</td>
                                                        <td className="border p-2">{gpForm26Dtls?.total?.totalPpaymentAmount}</td>
                                                        <td className="border p-2">{gpForm26Dtls?.total?.totalFundAvailable}</td>
                                                        <td className="border p-2">{gpForm26Dtls?.total?.totalPaymentCommitment}</td>
                                                        <td className="border p-2">{gpForm26Dtls?.total?.totalClosingBalance}</td>
                                                    </tr>
                                                </tfoot>
                                            </table>
                                        </div>
                                    </div>
                                </div>

                                <div className="flex justify-center space-x-4 py-1">
                                    <div className="text-right text-xs mt-4 italic">
                                        <button
                                            className="bg-green-500 text-white px-4 py-1 text-xs rounded hover:bg-green-600 transition duration-200"
                                            onClick={handlePrint}
                                        >
                                            Download PDF
                                        </button>
                                    </div>
                                </div>
                            </>
                        )}

                        {!reportLoading && (
                            (isCashAnalysisReport && !cashAnalysisSummaryDtls?.dtls?.length) ||
                            (isForm26Report && !gpForm26Dtls?.dtls?.length)
                        ) && (
                                <div
                                    className="flex items-center justify-center bg-gray-200"
                                    style={{ marginTop: "10px" }}
                                >
                                    <div className="text-center">
                                        <h1 className="text-xl font-semibold text-black-800">
                                            No Data Found
                                        </h1>
                                    </div>
                                </div>
                            )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default MonthClosingModule;